export enum FamilyRelationship {
  AuntOrUncle = 'AUNT_OR_UNCLE',
  Brother = 'BROTHER',
  Child = 'CHILD',
  Cousin = 'COUSIN',
  Daughter = 'DAUGHTER',
  Father = 'FATHER',
  Grandchild = 'GRANDCHILD',
  Grandparent = 'GRANDPARENT',
  GreatGrandfather = 'GREAT_GRANDFATHER',
  GreatGrandmother = 'GREAT_GRANDMOTHER',
  Mother = 'MOTHER',
  MaternalAunt = 'MATERNAL_AUNT',
  MaternalGrandfather = 'MATERNAL_GRANDFATHER',
  MaternalGrandmother = 'MATERNAL_GRANDMOTHER',
  MaternalUncle = 'MATERNAL_UNCLE',
  NieceOrNephew = 'NIECE_OR_NEPHEW',
  Other = 'OTHER',
  PaternalAunt = 'PATERNAL_AUNT',
  PaternalGrandmother = 'PATERNAL_GRANDMOTHER',
  PaternalGrandfather = 'PATERNAL_GRANDFATHER',
  PaternalUncle = 'PATERNAL_UNCLE',
  Sibling = 'SIBLING',
  Sister = 'SISTER',
  Son = 'SON',
  Spouse = 'SPOUSE',
}

export interface MedicalCondition {
  condition: string;
  conditionRaw: string;
}

export interface ConditionWithRelationship extends MedicalCondition {
  relationship: FamilyRelationship[];
  relationshipRaw: string[] | null;
}

export interface FamilyMedicalHistory {
  conditions: ConditionWithRelationship[];
}
